import React from "react";
import Image from "gatsby-image";
import { useTeamPhotos } from "shared/Hooks/About/Team";
import { BeefuryImage } from "./BeefuryImage";

export const BeefuryData = () => {
  const images = BeefuryImage();
  const team_images = useTeamPhotos();
  return {
    color: "#72FF00",
    title: "Beefury",
    seo:
      "Celem tych działań było wyróżnienie marki na tle konkurencji oraz podkreślenie jej oryginalności i wyjątkowości.",
    slug: "beefury",
    hero: {
      title: "Mocny przekaz na rynku.",
      color: "#72FF00",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_bg.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
    },
    what_we_did: {
      title: "Zastrzyk energii w identyfikacji wizualnej ",
      technologies: ["Identyfikacja wizualna", "Projekt opakowań", "Logo"],
      text:
        "Dla Beefury opracowaliśmy branding oraz projekty opakowań suplementów. Celem tych działań było wyróżnienie marki na tle konkurencji oraz podkreślenie jej oryginalności i wyjątkowości. Stworzona przez nas identyfikacja wizualna jest unikatowa i dopasowana do charakteru marki, której głównym przesłaniem jest moc, energia i ciągły rozwój.",
      list: [
        "Opracowaliśmy branding i naming marki",
        "Stworzyliśmy logo w oparciu o autorską ilustrację",
        "Zaprojektowaliśmy opakowania produktów",
      ],
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_4.childImageSharp.fluid}
        />
      ),
      fifth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_5.childImageSharp.fluid}
        />
      ),
      sixth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_6.childImageSharp.fluid}
        />
      ),
      seventh: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.bef_7.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.bef_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.bef_2f.childImageSharp.fluid}
          />
        ),
      },
    },
    text_boxes: {
      first: {
        title: "Silna komunikacja marki",
        text:
          "W logo firmy wykorzystaliśmy ilustrację pszczoły wykonaną przez naszego grafika. Symbolizuje ona siłę, co jest nawiązaniem do nazwy firmy oraz profilu działalności marki. W projekcie umieściliśmy również hasła przedstawiające wartości, którymi kieruje się Beefury. Wykorzystane kolory to biały, czarny i zielony. Barwy te uzupełniają się i razem tworzą interesujący przekaz.",
      },
      second: {
        title: "Przykuwający uwagę design",
        text:
          "Dla marki Beefury przygotowaliśmy również projekt opakowań suplementów. Zaprojektowane opakowania przykuwają uwagę i wyróżniają markę na tle innych. Są stylowe i designerskie, a swoją oryginalnością podkreślają profesjonalizm i jakość produktów firmy. Trudno przejść obok nich obojętnie.",
      },
    },
    marketing: {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team: [
        {
          name: "Patrycja Bilska",
          position: "Project Manager",
          image: (
            <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Skórka",
          position: "Frontend Developer",
          image: (
            <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid} />
          ),
        },
        {
          name: "Patryk Białas",
          position: "Graphic designer",
          image: (
            <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Krawiec",
          position: "Backend Developer",
          image: (
            <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Żmuda",
          position: "Marketing Specialist",
          image: (
            <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Furman",
          position: "Sales Manager",
          image: (
            <Image alt="" fluid={team_images.Furman.childImageSharp.fluid} />
          ),
        },
      ],
    },
  };
};
